export default __webpack_public_path__ + "static/media/ventury.d8176cb7.png";